import { ChevronLeft, ChevronRight, Maximize2, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useScrollLock } from "../hooks/useScrollLock";

export default function PropertyGallery({ property }) {
  const [activePhoto, setActivePhoto] = useState(null);
  const scrollPositionRef = useRef(null);
  const gallery = property.gallery?.length ? property.gallery : [property.image];
  const visiblePhotos = gallery.slice(0, 3);
  const previousPhoto = () => setActivePhoto((photo) => (photo - 1 + gallery.length) % gallery.length);
  const nextPhoto = () => setActivePhoto((photo) => (photo + 1) % gallery.length);

  useScrollLock(activePhoto !== null, "gallery-open", scrollPositionRef.current);

  const captureScrollPosition = () => {
    scrollPositionRef.current = window.scrollY;
  };

  useEffect(() => {
    if (activePhoto === null) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setActivePhoto(null);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [activePhoto]);

  return (
    <>
      <div className={`detail-gallery gallery-count-${visiblePhotos.length}`} data-testid="property-gallery">
        {visiblePhotos.map((photo, index) => <button className={`gallery-tile gallery-tile-${index}`} key={photo} onPointerDown={captureScrollPosition} onClick={() => setActivePhoto(index)} data-testid={`gallery-photo-${index}-button`} aria-label={`Agrandir la photo ${index + 1} sur ${gallery.length}`}><img src={photo} alt={`${property.title} — photo ${index + 1}`} loading={index === 0 ? "eager" : "lazy"} decoding="async" />{index === visiblePhotos.length - 1 && <span className="gallery-view-all"><Maximize2 size={16} /> Voir les {gallery.length} photos</span>}</button>)}
      </div>
      {activePhoto !== null && <div className="gallery-lightbox" role="dialog" aria-modal="true" aria-label={`Galerie photos de ${property.title}`} data-testid="gallery-fullscreen-modal">
        <button className="lightbox-close" onClick={() => setActivePhoto(null)} data-testid="gallery-close-button" aria-label="Fermer la galerie"><X size={24} /></button>
        {gallery.length > 1 && <button className="lightbox-nav lightbox-prev" onClick={previousPhoto} data-testid="gallery-previous-button" aria-label="Photo précédente"><ChevronLeft size={29} /></button>}
        <figure className="lightbox-figure"><img src={gallery[activePhoto]} alt={`${property.title} — photo ${activePhoto + 1}`} data-testid="gallery-fullscreen-image" /><figcaption data-testid="gallery-photo-counter">{activePhoto + 1} / {gallery.length}</figcaption></figure>
        {gallery.length > 1 && <button className="lightbox-nav lightbox-next" onClick={nextPhoto} data-testid="gallery-next-button" aria-label="Photo suivante"><ChevronRight size={29} /></button>}
      </div>}
    </>
  );
}